import PhotoSwipeLightbox from '../../../../../nelios-base/src/js/photoswipe/photoswipe-lightbox.esm.min';
import PhotoSwipe from '../../../../../nelios-base/src/js/photoswipe/photoswipe.esm.min';

export default class PhotoSwipeTheme {
    constructor(gallery) {
        if (!gallery) return;

		const lightbox = new PhotoSwipeLightbox({
			// bgOpacity: 0.2,
			gallery: gallery,
			children: 'a',
			pswpModule: PhotoSwipe
		});

		lightbox.init();
    }
}
